import React from "react";
import PropTypes from "prop-types";
import styles from "./ErrorLabel.module.scss";

export default function ErrorLabel({ name, formik, className }) {
  return (
    //formik.touched[name]
    <div className={styles.errorContainer}>
      { formik.errors[name] && (
        <span className={` ${styles.error} ${className}`}>
          {formik.errors[name]}
        </span>
      )}
    </div>
  );
}

ErrorLabel.propTypes = {
  name: PropTypes.string.isRequired,
  formik: PropTypes.object.isRequired,
  className: PropTypes.string,
};
